import { formatVND as fmtVND } from "./moneyFormat";

const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("vi-VN");
};

export const openVoucherPrintWindow = (title, rows, amount, status) => {
  const bodyRows = rows
    .map(([label, value]) => `<tr><td class="label">${label}</td><td>${value ?? "—"}</td></tr>`)
    .join("");

  const html = `<!DOCTYPE html>
<html lang="vi">
<head>
  <meta charset="utf-8" />
  <title>${title}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
    h1 { text-align: center; margin-bottom: 4px; }
    .sub { text-align: center; color: #666; margin-bottom: 24px; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
    td { padding: 8px 10px; border-bottom: 1px solid #eee; vertical-align: top; }
    td.label { width: 180px; font-weight: 600; color: #444; }
    .amount { font-size: 22px; font-weight: 700; text-align: right; margin-top: 12px; }
    .status { text-align: center; margin-top: 8px; color: #555; }
    @media print { body { margin: 0; } }
  </style>
</head>
<body>
  <h1>${title}</h1>
  <div class="sub">ZTO Vietnam — In lúc ${new Date().toLocaleString("vi-VN")}</div>
  <table>${bodyRows}</table>
  <div class="amount">Số tiền: ${fmtVND(amount)}</div>
  <div class="status">Trạng thái: ${status || "—"}</div>
  <script>window.onload = () => { window.print(); };</script>
</body>
</html>`;

  const win = window.open("", "_blank");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
};

export { fmtVND, fmtDate };
